import { Navigate } from "react-router-dom";
import { useAuthUser } from "./useAuthUser";

const ProtectedRoute = ({ children }) =>
{
  const { userAuth, loading } = useAuthUser();

  if (loading)
  {
    return (
      <div className="flex items-center justify-center min-h-screen">
        Loading...
      </div>
    );
  }

  if (!userAuth)
  {
    return <Navigate to="/signin" replace />;
  }

  if (!userAuth.emailVerified)
  {
    return (
      <Navigate
        to="/verify-email"
        state={{ email: userAuth.email }}
        replace
      />
    );
  }

  return children;
};

export default ProtectedRoute;